import subscribeToNewsletterGraphqlMutation from '~layers/app/graphql/subscribeToNewsletter.gql'

export function useNewsletter() {
  const email = useState('email', () => '')
  // const subscribeSource = useState('subscribeSource', () => '')
  const subscribe = useState('subscribe', () => undefined)
  const confirmed = useState('confirmed', () => false)

  const { show: showNotification } = useNotification()

  const { email: emailOnCart } = useCart()
  const { isLoggedIn, customerData } = useAccount()
  const watchersEnabled = ref<boolean>(false)

  if (!watchersEnabled.value) {
    watch(emailOnCart, (val) => {
      if (val) {
        email.value = val
      }
    }, { immediate: true })

    watch(isLoggedIn, () => {
      if (isLoggedIn) {
        email.value = customerData.value?.email
      }
    }, { immediate: true })

    watchersEnabled.value = true
  }

  const {
    mutate: subscribeToNewsletterMutation,
    loading: subscribeToNewsletterLoading,
    called: subscribeToNewsletterCalled,
    error: subscribeToNewsletterError,
  } = useMutation(
    subscribeToNewsletterGraphqlMutation,
    { clientId: 'customer' },
  )
  const confirm = async () => {
    if (confirmed.value || !subscribe.value || !email.value) {
      return true
    }

    try {
      await subscribeToNewsletterMutation({
        email: email.value,
      })
      confirmed.value = true

      return true
    }
    catch (subscribeToNewsletterException: any) {
      console.error('subscribeToNewsletterException', subscribeToNewsletterException)

      showNotification({
        type: 'error',
        message: useMessageHandler(subscribeToNewsletterException.message),
      })
    }

    return false
  }

  return {
    subscribe,
    confirmed,
    subscribeToNewsletterLoading,
    subscribeToNewsletterError,
    subscribeToNewsletterCalled,
    confirm,
    email,
  }
}
